var TscPrimitive = {
  neutral: {
    50: '#f8f9fa',
    75: '#f4f5f6',
    100: '#eff0f1',
    200: '#e2e4e5',
    300: '#d1d4d5',
    400: '#b5babb',
    500: '#a3a9aa',
    600: '#6c7678',
    700: '#555c5e',
    800: '#3c4243',
    900: '#353a3b',
    1000: '#2f3334',
    1100: '#212425',
    1200: '#141616',
    white: '#ffffff',
    alpha: {
      50: {
        50: 'rgba(248, 249, 250, 0.05)',
        100: 'rgba(248, 249, 250, 0.10)',
        150: 'rgba(248, 249, 250, 0.15)',
        200: 'rgba(248, 249, 250, 0.20)',
        300: 'rgba(248, 249, 250, 0.30)',
        350: 'rgba(248, 249, 250, 0.35)',
        400: 'rgba(248, 249, 250, 0.40)',
        450: 'rgba(248, 249, 250, 0.45)',
        500: 'rgba(248, 249, 250, 0.50)',
        550: 'rgba(248, 249, 250, 0.55)',
        600: 'rgba(248, 249, 250, 0.60)',
        650: 'rgba(248, 249, 250, 0.65)',
        700: 'rgba(248, 249, 250, 0.70)',
        750: 'rgba(248, 249, 250, 0.75)',
        800: 'rgba(248, 249, 250, 0.80)',
        850: 'rgba(248, 249, 250, 0.85)',
        900: 'rgba(248, 249, 250, 0.90)',
        950: 'rgba(248, 249, 250, 0.95)'
      },
      100: {
        50: 'rgba(239, 240, 241, 0.05)',
        100: 'rgba(239, 240, 241, 0.10)',
        150: 'rgba(239, 240, 241, 0.15)',
        200: 'rgba(239, 240, 241, 0.20)',
        300: 'rgba(239, 240, 241, 0.30)',
        400: 'rgba(239, 240, 241, 0.40)',
        500: 'rgba(239, 240, 241, 0.50)',
        600: 'rgba(239, 240, 241, 0.60)',
        700: 'rgba(239, 240, 241, 0.70)',
        750: 'rgba(239, 240, 241, 0.75)',
        800: 'rgba(239, 240, 241, 0.80)',
        850: 'rgba(239, 240, 241, 0.85)',
        900: 'rgba(239, 240, 241, 0.90)',
        950: 'rgba(239, 240, 241, 0.95)'
      },
      1000: {
        50: 'rgba(47, 51, 52, 0.05)',
        100: 'rgba(47, 51, 52, 0.10)',
        150: 'rgba(47, 51, 52, 0.15)',
        200: 'rgba(47, 51, 52, 0.20)',
        300: 'rgba(47, 51, 52, 0.30)',
        400: 'rgba(47, 51, 52, 0.40)',
        500: 'rgba(47, 51, 52, 0.50)',
        600: 'rgba(47, 51, 52, 0.60)',
        700: 'rgba(47, 51, 52, 0.70)',
        750: 'rgba(47, 51, 52, 0.75)',
        800: 'rgba(47, 51, 52, 0.80)',
        850: 'rgba(47, 51, 52, 0.85)',
        900: 'rgba(47, 51, 52, 0.90)',
        950: 'rgba(43, 52, 52, 0.95)'
      },
      1100: {
        50: 'rgba(33, 36, 37, 0.05)',
        100: 'rgba(33, 36, 37, 0.10)',
        150: 'rgba(33, 36, 37, 0.15)',
        200: 'rgba(33, 36, 37, 0.20)',
        300: 'rgba(33, 36, 37, 0.30)',
        400: 'rgba(33, 36, 37, 0.40)',
        500: 'rgba(33, 36, 37, 0.50)',
        600: 'rgba(33, 36, 37, 0.60)',
        700: 'rgba(33, 36, 37, 0.70)',
        750: 'rgba(33, 36, 37, 0.75)',
        800: 'rgba(33, 36, 37, 0.80)',
        850: 'rgba(33, 36, 37, 0.85)',
        900: 'rgba(33, 36, 37, 0.90)',
        950: 'rgba(32, 35, 38, 0.95)'
      },
      white: {
        25: 'rgba(255, 255, 255, 0.02)',
        50: 'rgba(255, 255, 255, 0.05)',
        75: 'rgba(255, 255, 255, 0.07)',
        100: 'rgba(255, 255, 255, 0.10)',
        125: 'rgba(255, 255, 255, 0.12)',
        150: 'rgba(255, 255, 255, 0.15)',
        200: 'rgba(255, 255, 255, 0.20)',
        250: 'rgba(255, 255, 255, 0.25)',
        300: 'rgba(255, 255, 255, 0.30)',
        350: 'rgba(255, 255, 255, 0.35)',
        400: 'rgba(255, 255, 255, 0.40)',
        450: 'rgba(255, 255, 255, 0.45)',
        500: 'rgba(255, 255, 255, 0.50)',
        550: 'rgba(255, 255, 255, 0.55)',
        600: 'rgba(255, 255, 255, 0.60)',
        650: 'rgba(255, 255, 255, 0.65)',
        700: 'rgba(255, 255, 255, 0.70)',
        750: 'rgba(255, 255, 255, 0.75)',
        800: 'rgba(255, 255, 255, 0.80)',
        850: 'rgba(255, 255, 255, 0.85)',
        900: 'rgba(255, 255, 255, 0.90)',
        950: 'rgba(255, 255, 255, 0.95)',
        0: 'rgba(255, 255, 255, 0.00)'
      },
      black: {
        50: 'rgba(0, 0, 0, 0.05)',
        100: 'rgba(0, 0, 0, 0.10)',
        150: 'rgba(0, 0, 0, 0.15)',
        200: 'rgba(0, 0, 0, 0.20)',
        250: 'rgba(0, 0, 0, 0.25)',
        300: 'rgba(0, 0, 0, 0.30)',
        350: 'rgba(0, 0, 0, 0.35)',
        400: 'rgba(0, 0, 0, 0.40)',
        450: 'rgba(0, 0, 0, 0.45)',
        500: 'rgba(0, 0, 0, 0.50)',
        550: 'rgba(0, 0, 0, 0.55)',
        600: 'rgba(0, 0, 0, 0.60)',
        650: 'rgba(0, 0, 0, 0.65)',
        700: 'rgba(0, 0, 0, 0.70)',
        750: 'rgba(0, 0, 0, 0.75)',
        800: 'rgba(0, 0, 0, 0.80)',
        850: 'rgba(0, 0, 0, 0.85)',
        900: 'rgba(0, 0, 0, 0.90)',
        950: 'rgba(0, 0, 0, 0.95)',
        0: 'rgba(0, 0, 0, 0.00)'
      }
    },
    black: '#000000'
  },
  sky: {
    50: '#eefaff',
    100: '#ccf0ff',
    200: '#a8e5ff',
    300: '#75d6ff',
    400: '#40c6ff',
    500: '#1db1fc',
    600: '#0699ef',
    700: '#087acb',
    800: '#005499',
    900: '#00457a',
    1000: '#02243d'
  },
  fern: {
    50: '#daf7e7',
    100: '#c3f1d8',
    200: '#95e3b9',
    300: '#68d699',
    400: '#3ac87a',
    500: '#0cbb5b',
    600: '#0a9649',
    700: '#077037',
    800: '#054b24',
    900: '#04381b'
  },
  slime: {
    50: '#e5ffd1',
    100: '#bcff87',
    200: '#9efd53',
    300: '#98f12f',
    400: '#8eeb21',
    500: '#84e117',
    600: '#70cd03',
    700: '#52af00',
    800: '#398f00',
    900: '#1e7500'
  },
  cardinal: {
    50: '#ffe5e5',
    100: '#ffcccc',
    200: '#fa9e9e',
    300: '#ed685e',
    400: '#e83d30',
    500: '#c82a1f',
    600: '#af271e',
    700: '#96251d',
    800: '#7e211b',
    900: '#641b16'
  },
  berry: {
    50: '#ffe3f5',
    100: '#ffb2e3',
    200: '#ff85d2',
    300: '#ff61c5',
    400: '#f53db2',
    500: '#e10992',
    600: '#cc0081',
    700: '#a70669',
    800: '#7c054c',
    900: '#580436'
  },
  sunrise: {
    50: '#fff9ea',
    100: '#ffeebe',
    200: '#ffe69f',
    300: '#ffda73',
    400: '#ffd258',
    500: '#ffc82e',
    600: '#ffba24',
    700: '#ffa42e',
    800: '#ef8200',
    900: '#e56700'
  },
  violet: {
    50: '#f1e0ff',
    100: '#d5a3ff',
    200: '#c075ff',
    300: '#ad4dff',
    400: '#962eef',
    500: '#8428d2',
    600: '#6d27ce',
    700: '#562bb5',
    800: '#462a84',
    900: '#342357'
  }
};
export default TscPrimitive;